import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { getFieldErrors } from '@/services/api';
import { usePlanMutations } from '../hooks/usePlanMutations';
import { PlanForm } from '../components/PlanForm';
import type { PlanFormInput, PlanFormOutput } from '../schemas/plan.schema';
import type { UseFormSetError } from 'react-hook-form';

export function PlanCreate() {
    const navigate = useNavigate();
    const { createMutation } = usePlanMutations();
    const setErrorRef = useRef<UseFormSetError<PlanFormInput> | null>(null);

    const handleSubmit = (data: PlanFormOutput) => {
        createMutation.mutate(
            { name: data.name, description: data.description, status: data.status, is_looped: data.is_looped },
            {
                onSuccess: (created) => navigate(`/smr-admin/plans/${created.id}`),
                onError: (err: unknown) => {
                    // getFieldErrors reads error.errors first, then the top-level errors compat
                    // key, so this survives slice 3 without a further edit. Always an object,
                    // so the previous field-map presence guard is gone.
                    Object.entries(getFieldErrors(err)).forEach(([field, messages]) => {
                        setErrorRef.current?.(field as keyof PlanFormInput, { message: messages[0] });
                    });
                },
            },
        );
    };

    return (
        <section className="space-y-4">
            <h1 className="text-2xl font-semibold">New Plan</h1>
            <PlanForm
                onSubmit={handleSubmit}
                isLoading={createMutation.isPending}
                submitLabel="Create Plan"
                onSetErrorRef={(fn) => { setErrorRef.current = fn; }}
            />
        </section>
    );
}
